module.exports = __webpack_public_path__ + "static/media/capsule.d17d4b22.png";